import { apiFetch, readErrorMessage } from '../api/client';
import { USER_STORAGE_MOUNT_ID } from '../storageFileAudit/formatters';
import { normalizeContentFolderPathOrRoot } from './defaultContentFolderPrefs';
import { mountApiBase } from './fileBrowserApi';

/**
 * Ensures each segment of a My Storage-relative folder path exists.
 * Treats HTTP 409 (already exists) as success. No-op for root/empty.
 */
export async function ensureUserStorageFolder(
  folderPath: string,
  mountId: string = USER_STORAGE_MOUNT_ID
): Promise<string> {
  const normalized = normalizeContentFolderPathOrRoot(folderPath);
  if (!normalized) return '';

  const segments = normalized.split('/').filter(Boolean);
  let accum = '';
  for (const segment of segments) {
    accum = accum ? `${accum}/${segment}` : segment;
    const res = await apiFetch(`${mountApiBase(mountId)}/directories`, {
      method: 'POST',
      body: JSON.stringify({ path: accum })
    });
    if (res.ok || res.status === 409) continue;
    throw new Error(await readErrorMessage(res));
  }
  return normalized;
}
